import React from "react";
import { AppBar, Toolbar, Box, Button, IconButton, Grid } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';

const WebAppHeader = ({ 
  t, 
  i18n, 
  changeLanguage, 
  onClickGoToPage, 
  onOpenDrawer, 
  view, 
  Logo, 
  icons 
}) => {
  const { 
    HomeIcon, 
    InfoOutlinedIcon, 
    GroupsOutlinedIcon, 
    VectorIcon, 
    PostAddOutlinedIcon 
  } = icons;

  const handleAboutClick = () => {
    if (view === "Landing" || window.location.pathname === "/" || window.location.pathname === "/landing") {
      setTimeout(() => {
        const learnMoreSection = document.querySelector('[data-section="learn-more"]');
        if (learnMoreSection) {
          learnMoreSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const eventHandler = onClickGoToPage("Landing");
      eventHandler();
      localStorage.setItem('scrollToLearnMore', 'true');
    }
  };

  const handleNav = (page) => {
    const eventHandler = onClickGoToPage(page);
    eventHandler();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Grid sx={{ paddingRight: "40px" }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          gap: "20px",
          paddingRight: { md: "60px", sm: "10px", xs: "10px" },
          position: "relative",
        }}
      >
        {/* Logo Section */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "8px",
            cursor: "pointer",
          }}
          onClick={() => handleNav("Landing")}
        >
          <img
            alt="Wisdom"
            src={Logo}
            style={{ width: "150px", height: "auto", paddingLeft: "15px", paddingTop: "5px" }}
          />
        </div>
        {/* Desktop Navigation */}
        <AppBar
          position="static"
          sx={{
            display: { xs: "none", md: "flex" },
            justifyContent: "flex-end",
            width: "90%",
            background: "linear-gradient(90deg, #FDD6EE 0%, #FBF6FF 50.77%, #DCE6FB 100%)",
            height: "72px",
            borderRadius: "20px",
            marginTop: "28px",
            boxShadow: "none",
          }}
        >
          <Toolbar
            sx={{
              width: "96%",
              padding: "0 2%",
              display: "flex",
              gap: "30px",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "35px" }}>
              <Box sx={{ display: "flex", gap: "30px" }}>
                <Button sx={navBtnStyle} startIcon={<HomeIcon />} onClick={() => handleNav("Landing")}>
                  {t('nav.home')}
                </Button>

                <Button sx={navBtnStyle} startIcon={<InfoOutlinedIcon />} onClick={handleAboutClick}>
                  {t('nav.about')}
                </Button>

                <Button sx={navBtnStyle} startIcon={<GroupsOutlinedIcon />} onClick={() => handleNav("About")}>
                  {t('nav.team')}
                </Button>

                <Button sx={navBtnStyle} startIcon={<VectorIcon />} onClick={() => handleNav("FAQ")}>
                  {t('nav.faq')}
                </Button>

                <Button sx={navBtnStyle} startIcon={<PostAddOutlinedIcon />} onClick={() => handleNav("Publications")}>
                  {t('nav.publications')}
                </Button>

                {/* Language Switcher */}
                <Button 
                  variant="outlined" 
                  size="small"
                  onClick={() => changeLanguage(i18n.language === 'en' ? 'es' : 'en')}
                  sx={{ borderRadius: "20px", borderColor: "#D80C8C", color: "#D80C8C", fontWeight: "bold" }}
                >
                  {i18n.language === 'en' ? 'Español' : 'English'}
                </Button>

                {/* Join/Enroll Button */}
                <Button
                  sx={joinBtnStyle}
                  onClick={() => window.open("https://www.redcap.link/wisdomibdstudy", "_blank")}
                >
                  {t('nav.join')}
                </Button>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
            {/* Mobile Menu Icon */}
        <IconButton
          aria-label="menu"
          onClick={onOpenDrawer}
          sx={{
            display: { xs: "flex", md: "none" },
            position: "absolute",
            right: "15px",
            top: "50px",
            zIndex: 1001,
          }}
        >
          <MenuIcon />
        </IconButton>
      </Box>
    </Grid>
  );
};

const navBtnStyle = {
  color: "rgba(68, 71, 80, 1)",
  textTransform: "none",
  fontSize: "14px",
  fontWeight: 400,
};

const joinBtnStyle = {
  fontWeight: 500,
  fontSize: { md: "16px", sm: "14px", xs: "12px" },
  color: "#FFFFFF",
  backgroundColor: "#D80C8C",
  padding: "8px 16px",
  borderRadius: "10px",
  "&:hover": { backgroundColor: "#D80C8C" },
  textTransform: "none",
};

export default WebAppHeader;